import { render } from "./DocsLastActionFeedback.vue?vue&type=template&id=2efd94a0"
import script from "./DocsLastActionFeedback.vue?vue&type=script&lang=js"
export * from "./DocsLastActionFeedback.vue?vue&type=script&lang=js"
script.render = render

export default script